import React from 'react';

export default function RouteLoadingFallback({workspace = false}) {
  if (workspace) {
    return (
      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-8" role="status" aria-live="polite">
        <span className="sr-only">Loading your workspace…</span>
        <div className="animate-pulse space-y-7 motion-reduce:animate-none" aria-hidden="true">
          <div className="space-y-3">
            <div className="h-3 w-24 rounded-full bg-slate-200" />
            <div className="h-8 w-64 max-w-[75%] rounded-xl bg-slate-200" />
            <div className="h-4 w-80 max-w-full rounded-full bg-slate-100" />
          </div>
          <div className="grid gap-4 sm:grid-cols-3">
            {[0, 1, 2].map((item) => (
              <div key={item} className="h-28 rounded-2xl border border-slate-200/80 bg-white" />
            ))}
          </div>
          <div className="rounded-2xl border border-slate-200/80 bg-white p-5 sm:p-6">
            <div className="h-5 w-40 rounded-full bg-slate-200" />
            <div className="mt-5 space-y-3">
              <div className="h-4 w-full rounded-full bg-slate-100" />
              <div className="h-4 w-11/12 rounded-full bg-slate-100" />
              <div className="h-4 w-3/4 rounded-full bg-slate-100" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="grid min-h-screen place-items-center bg-surface px-4"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-3 text-sm font-semibold text-primary">
        <span className="h-5 w-5 animate-spin rounded-full border-2 border-primary/25 border-t-primary motion-reduce:animate-none" aria-hidden="true" />
        Loading your workspace…
      </div>
    </div>
  );
}
